// 西班牙语
export default {
  language: "Español",
  desc: "¿Quiénes somos?",
  myagency: "MI Agencia",
  joinAgency: "Únete a agencia",
  youNeedFaceVerify: "Por favor toma un video mostrando tu rostro",
  writeGuildId: "Por favor ingresa el ID del gremio",
  checkAgreement: "Por favor revisa el acuerdo",
  edit: "Editar",
  easyEarn: "Gana fácilmente más de",
  month: "+ por mes",
  applyHost: "Solicitar convertirse en un",
  voiceHost: "host de sala de chat de voz",
  oneHost: "host 1v1",
  ultraFast: "Verificación de Host Ultra-Rápida",
  onePhone: "Comienza a ganar con solo un teléfono",
  "complete.personal.information": "Completa Información Personal",
  "change.avatar": "Cambiar Avatar",
  "fill.signature": "Rellenar Firma Personal",
  "upload.photo.wall": "Sube 3 fotos en el muro de fotos",
  "profile.private.photos": "Profile & private photos",
  MaterialsCompleted: "Materiales completados",
  MaterialsUnfinished: "Tienes materiales incompletos",
  "enter.guildId": "Ingresa el ID del gremio que deseas unirte",
  "facial.verification": "Verificación Facial",
  "verification.completed": "La verificación ha sido completada",
  "take.video.face": "Toma un video mostrando tu rostro",
  reviewing: "Revisando",
  "under.review": "En Revisión...",
  "wait.review": "Por favor, espera pacientemente la aprobación",
  "applicant.rejected": "Solicitud Rechazada",
  "resubmit.desc": "Solicitud rechazada. Solicitud rechazada. Puedes volver a enviar.",
  "no.resubmit.desc": "Application rejected. No se puede volver a enviar.",
  resubmit: "Volver a enviar para revisión",
  "reason.for.rejection": "Motivo del rechazo:",
  "last.3.photos": "La verificación de host requiere al menos 3 fotos",
  vertify: "Verificar",
  submit: "Enviar",
  agreeto: "Aceptar el ",
  achorgreement: "Acuerdo de Instalación del Host",
  "streamer.agreement": "Acuerdo de Streamer",
  "upload.profile": "Sube tu foto de perfil",
  // 我的工会
  leader: "Líder",
  myAgencyIncome: "Mis Ingresos de la Agencia",
  totalStreamers: "Total de Streamers",
  diamondIncome: "Ingresos por Diamantes",
  charmIncome: "Ingresos por Encanto",
  hostList: "Lista de Hosts",
  enterUID: "Ingresar UID",
  no: "No.",
  hostInfo: "Información del Host",
  // 邀请页
  get: "Obtener",
  "when.your.invite.registers": "cuando tu invitado se registre  ",
  "commission.y.i": `commission on your invite's spending `,
  "within.d.r": "dentro de los 30 días posteriores al registro  ",
  "when.y.j": "cuando tu invitado se una a la ",
  agency: "agencia",
  "when.y.c": "cuando tu invitado complete una",
  "valid.w.s": "semana válida de transmisión",
  "commission.i": "comisión sobre los ingresos de tu invitado",
  "income.d.s": "durante 14 días después de la verificación exitosa",
  "get.i.r": "Obtén un 8% de comisión sobre las compras de monedas de tu invitado durante 30 días después del registro",
  "when.b.a": "cuando tu invitado se convierta en un",
  "verified.s": "transmisor verificado y transmita en Modo Trabajo durante al menos 3 días durante su primera semana",
  "rewards.claimed": "Recompensas reclamadas",
  "view.detail": "Ver detalle",
  withdraw: "Retirar",
  "copy.c": "Copiar tu código de invitación",
  "copy.a.c": "Copiar tu ID de agencia",
  "copy.f.c": "Copiar el ID de la agencia del amigo",
  copy: "Copiar",
  "your.f.l": "Tus amigos abren o descargan Sallo a través del enlace",
  "your.f.s": "Tus amigos ingresan tu código de invitación y lo envían",
  "Your.f.f.s": "Tu amigo ingresa tu ID de Agencia al postularse a la agencia",
  "f.f.a": "Ingresa ID de Agencia del amigo para postularte",
  "the.a": "La Agencia aprueba tu solicitud",
  "your.invites": "Tus Invitados",
  "user.info": "Información del usuario",
  contribution: "Contribución",
  date: "Fecha",
  "no.messages.yet": "No hay mensajes aún",
  "share.invite.link": "Compartir Enlace",
  "invite.users": "Invitar Amigos",
  "invite.host": "Invitar Anfitrión",
  // 被邀请页
  earn: "Ganar",
  "easily.m": "Fácilmente cada mes",
  "voice.c": "Transmisión en vivo de chat de voz, llamadas/video 1 a 1",
  "fast.s": "Verificación rápida de transmisor — comienza a ganar solo con tu teléfono",
  "claim.f": "Reclama tiempo de suscripción premium gratis, tokens y regalos",
  "lots.o": "Muchos tipos de transmisores e interacciones profundas",
  "open.sallo": "Abrir Sallo",
  // 主播中心
  "host.center": "Centro de host",
  "charm.Income": "Ingreso encanto",
  "upgrade.to": "Actualizar a",
  "still.need": "Todavía necesitas",
  "to.next.level": "para el siguiente nivel",
  today: "Hoy",
  week: "Semana",
  "my.questions": "Mis Preguntas",
  "online.data": "Datos en línea",
  "availability.duration": "Duración de disponibilidad",
  "in-room.duration": "Duración In-Room",
  "call.data": "Datos de llamadas",
  matches: "coincidencia",
  calls: "Llamadas",
  "success.rate": "Tasa de éxito",
  "income.data": "Datos de ingresos",
  charm: "Encanto",
  "gift.income": "Ingresos por regalos",
  "call.income": "Ingresos por llamadas",
  overview: "Resumen",
  "total.income": "Ingreso total",
  "average.duration": "Duración Promedio",
  "pm.income": "Ingresos PM",
  "task.income": "Ingresos por Tareas",
  // 任务中心
  tasks: "Tareas",
  "claimed.coins": "Monedas reclamadas",
  "claimed.diamonds": "Diamantes reclamados",

  "diamond.Withdrawal.rules": "Reglas de retiro de diamantes",
  "diamond.Withdrawal.rules.content": "5.000 diamantes = 1 dólar",
  "withdrawal.applications": "estadounidense  Solicitudes de retiro",
  "withdrawal.applications.content": "Todos los lunes y martes",
  "withdrawal.received": "Recepción del retiro",
  "withdrawal.received.content": "Todos los miércoles",

  "message.example": "Ejemplo de mensaje:",
  "note:": "Nota:",
  "message.example.content":
    "Escribe textos de al menos 30 caracteres para recibir la recompensa. La palabra «Hola» equivale a 3 caracteres.No copies el ejemplo textualmente. Muestra tu propio encanto y estilo.",
  step1: "Paso1",
  "find.a.user": "Busca un usuario con la marca de nuevo. Es un usuario completamente nuevo en la plataforma.",
  step2: "Paso2",
  "message.him":
    "Envíale un mensaje y guíale para que realice su primer recarga. Después de la primera recarga, habrá un collar especial en su mochila.",
  Step3: "Paso3",
  "ask.him": "Pídele que te envíe el collar por el chat del salón o por mensaje privado.",
  "in.room": "En la sala",
  "to.find": "para buscar el collar.",
  "in.message": "En mensaje privado",
  next: "Siguiente",
  go: "Ir",

  "invite.a.new.host": "Invitar a una nueva presentadora",
  "invite.a.new.user": "Invitar a un nuevo usuario",

  "invite.host.and": "¡Invita anfitriones y obtén generosas recompensas! Invita a tus amigos a unirse ahora mismo~",
  "Invite.Rewards": "Recompensas por invitación:",

  "Get.1000": "Obtén 1000 diamantes inmediatamente cuando tu amigo sea verificado como anfitrión.",
  "Get.2500": "Obtén 2500 diamantes cuando tu amigo transmita durante una semana completa (12 horas semanales).",
  "Get.5":
    "Obtén una comisión del 5% sobre los ingresos de tu amigo durante 14 días después de la verificación exitosa.",
  "You.Can.Check": "Puedes consultar las recompensas en la sección «Invitar y ganar» de tu página personal.",

  "Invite.user.and": "¡Invita a tus usuarios/jefes y obtén generosas recompensas! Las recargas aquí son súper baratas~",
  "Get.2500.2": "Obtén 2500 diamantes inmediatamente cuando tu usuario/jefe se registre.",
  "Get.5.2": "Obtén una comisión del 5% sobre el gasto de tu usuario/jefe durante 30 días después del registro. ",

  regular: "Regular",
  diamonds: "Diamantes",
  "first.recharge": "Primer recargo",
  "first.t": "Primer envío de regalos",
  "first.p": "Primer PM",
  "first.v": "Primera videollamada",
  "following.friends": "Siguiendo a amigos*3",
  "speaking.i": "Hablando en una sala de chat de voz",
  completed: "Completado",
  incomplete: "Incompleto",
  "new.h": "Nueva Tarea de host",
  "ends.in": "Finaliza en",
  days: "días",
  "daily.tasks": "Tareas Diarias",
  "weekly.tasks": "Tareas Semanales",
  "monthly.tasks": "Tareas Mensuales",
  // 账号管理
  manage: "Gestionar",
  "submitted.successfully": "Enviado con éxito",
  "please.name": "Por favor, ingresa el Nombre Completo Registrado en GCash.",
  "please.number": "Por favor, ingresa el Número de Teléfono Registrado en GCash.",
  "please.content": "Por favor, lee y comprende este contenido.",
  "please.trc-20": "Por favor, ingresa el TRC-20.",
  "please.address": "Por favor, ingresa la Dirección TRC20.",
  "please.understand": "Por favor, lee y comprende este contenido.",
  "please.format": "Por favor, confirma que esta red está en el formato TRC-20.",
  fee: "Tarifa",
  "no.message": "No hay mensajes aún",
  "add.bank": "Agregar tarjeta bancaria",
  country: "País",
  confirm: "Confirmar",
  "bind.account": "Vincular Cuenta",
  "gcash.name": "Nombre Completo Registrado en GCash",
  "gcash.number": "Número de Teléfono Registrado en GCash",
  "gcash.number.placeholder": "Ingresa el número móvil de 11 dígitos que comienza con 09, ej., 0917 123 4567",
  "important.note": "Nota Importante",
  "please.ensure":
    "Por favor, asegúrate de que el nombre y el número de teléfono coincidan estrictamente con la información de tu cuenta de GCash, de lo contrario, el retiro fallará.",
  "is.correct": "He confirmado que toda la información es correcta.",
  "transfer.network": "Red de Transferencia",
  "is.trc": "He confirmado que la red es TRC-20",
  "trc.address": "Dirección TRC20",
  "trc.address.placeholder": 'Pega la dirección TRC-20 (Comienza con "T")',
  "your.funds":
    "Asegúrate de que la moneda y la red seleccionadas coincidan estrictamente con los detalles de tu intercambio. Cualquier transacción incorrecta puede llevar a la pérdida permanente de tus fondos.",
  "above.risks": "He leído y comprendido los riesgos mencionados anteriormente.",
  "details.carefully":
    "Por favor, asegúrate de que el nombre coincida estrictamente con la información de tu cuenta bancaria, de lo contrario, el retiro fallará. Por favor, verifica cuidadosamente los detalles de tu banco.",
  // 提现
  withdrawal: "Retiro",
  quantity: "Cantidad",
  "please.amount": "Por favor, ingresa la Cantidad.",
  "minimum.withdrawal.25k": "Retirada mínima de 25k.",
  "minimum.withdrawal.35k": "Retirada mínima de 35k.",
  "please.diamond": "Por favor, ingresa el diamante correcto.",
  "diamond.withdraw": "Retiro de diamantes",
  "withdrawal.usd": "Retiro: $4.0 USD (Tarifa de transacción: $2.0)",
  "the.credited": "El monto acreditado se basará en la tasa de cambio de la moneda local",
  "exchange.rate": "al momento de acreditar.",
  "minimum.withdrawal.5": "5K Diamantes = 1 USD. Retiro mínimo de $5.",
  "minimum.withdrawal.7": "5K Diamantes = 1 USD. Retiro mínimo de $7.",
  "withdrawals.must": "Los retiros deben ser en múltiplos de 1k.",
  cashable: "Canjeable",
  "amount.usd": "Monto(USD)",
  amount: "Monto",
  all: "TODO",
  "transacton.fee": "Tarifa de transacción: $2.00",
  "withdraw.to": "Retirar a",
  "manage.account": "Gestionar Cuenta",
  "my-account": "Mi Cuenta",
  account: "Cuenta",
  "agency.account": "Cuenta de la Agencia",
  "the.last": "El último ajuste falló. Por favor, verifica tu información.",
  "agency.owner": "Propietario de la Agencia",
  "withdrawals.will": "Los retiros se transferirán a la cuenta consolidada de la Agencia.",
  "fee.usd": "Tarifa(USD)",
  usd: "USD",
  "will.reduce": "Esto reducirá",
  "invitation.copy.success": "Tu enlace ha sido copiado",
  "enter.amound.1": "Retiro mín. $1",
  "enter.amound.7": "Retiro mín. $7",
  "enter.dimond": "Ingresar cantidad de dimond",
  "in.diamond": "en Diamond Net Earnings",
  "diamond.net":
    "Diamond Net Earnings se refieren a los ingresos generados específicamente por mensajes privados, matches, videollamadas y regalos dimond (Esto no incluye recompensas de tareas, ingresos por charms ni otros bonos). Las recompensas se emitirán a la cuenta del host el lunes siguiente.",
  "upgrader.to": "Actualizar a",
  directions: "Instrucciones",
  charms: "Charms",
  "task.calculation":
    "Solo los charms provenientes de nuevos usuarios（registrados dentro de los 30 días）se incluyen en las estadísticas de la tarea; los charms provenientes de usuarios existentes y hosts no se incluyen en el cálculo de la tarea.",
  claimed: "Reclamado",
  obtained: "Obtenido",
  "add.withdrawal": "Agregar cuenta de retiro",
  supports: "Compatible con GCash y USDT",

  reward: "Recompensa :",
  "diamonds.pre": "($1) por cada anfitrión válido. Más invitaciones, más recompensas. Sin límite.",

  "valid.host": "Anfitrión válido: ",
  "certified.and.earns": "Certificado y gana ",
  "within.7.days": "en 7 días.",

  "please.select": "Por favor, seleccione un archivo de música en formato MP3",
  "file.size": "Selecciona un archivo de música entre 512KB y 8MB",
  "daily.music.limit": "Límite diario de importación alcanzado",
  "music.limit": "Límite de importación de música alcanzado",
  "import.music": "Importar música",
  "mobile.import": "Importación desde celular",
  "connected.wifi": "· Asegúrate de que tu celular esté conectado a WiFi",
  "tap.below": '· Toca el botón "Importar" abajo',
  "between.512K.8M": "· Selecciona un archivo de audio (mp3) entre 512K y 8M",
  "submit.import": "· Enviar para importar",
  import: "Importar",
  "import.failed": "Error de importación",
  "import.success": "Importación exitosa",
  "network.delay": "Retardo de red",
  importing: "Importando...",
  "song.name": "Nombre de la canción",
  status: "Estado",
  success: "correctamente",
  failed: "Error",
  close: "Cerrar",
  "please.do.not.close":
    "No cierre la página hasta que finalice la importación. Cerrarla durante el proceso puede provocar que la importación falle.",
  "content.fail": "Hay contenido en proceso de importación. Cerrar la página hará que la importación falle.",
  cancel: "Cancelar",
  "sensitive.info": "Sensible info",
  "matched.calls": "Llamadas Emparejadas",
  "card.calls": "llamadas de tarjetas",
  "today.answered": "Hoy atendidas:",
  "still.to.answer": "Por responder:",
  "First.peak.period": "Segundo horario pico",
  "9.00": "09:00–12:00 hora Beijing Time (UTC+8)",
  Or: "o",
  "21.00": "21:00–00:00 hora del Este (UTC-4)",

  "Second.peak.period": "Segundo horario pico",
  "14.00": "2:00-5:00 hora Beijing (UTC+8)",
  "14.00.2": "14:00-17:00 hora del Este (UTC-4)",
};
